import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { LOAD, LOAD_END } from '../../../../../../../store/actions/actionsTypes'
import { Miun } from '../../../../../../modules/API/Miun/miun'
import { ISortingListItem } from '../../../../../../modules/API/Miun/models/sortingList'
import { ContextModal } from '../../../../../../modules/modal/modalContext'
import { addIDForTheList } from '../../../../../../generic/utils/addUIDForTheList'
import uuid from 'react-uuid'
import useMiunDateRange from './useMiunDateRange'

const useMiunList = () => {
    const dispatch = useDispatch()
    const [modal, setModal] = useContext(ContextModal)
    const { from, to, setRange } = useMiunDateRange()

    const [data, setData] = useState<ISortingListItem[]>()
    const [input, setInput] = useState<string>('')
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const getSorting = useCallback(async () => {
        dispatch({ type: LOAD })
        setIsLoading(true)
        try {
            const res = await Miun.getSortingByDates(from, to)
            setData(addIDForTheList(res))
        } catch {
            setModal({ open: true, value: 'משהו השתבש', mood: false })
            setTimeout(() => setModal({ ...modal, open: false }), 3000)
        } finally {
            dispatch({ type: LOAD_END })
            setIsLoading(false)
        }
    }, [from, to, dispatch, setModal, modal])

    useEffect(() => {
        getSorting()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [from, to])

    const uppendData = useCallback((item: ISortingListItem) => {
        if (!item) return
        setData((prev) => [{ ...item, id: uuid() } as ISortingListItem, ...(prev || [])])
    }, [])

    const renderData = useMemo(() => {
        if (!data) return []
        const q = input.trim().toLowerCase()
        if (!q) return data
        return data.filter((item) =>
            `${item.ProductDesc?.trim()} ${item.VarietyDesc?.trim()}`.toLowerCase().includes(q) ||
            (item.GrowerName?.trim().toLowerCase().includes(q) ?? false),
        )
    }, [data, input])

    return {
        from,
        to,
        setRange,
        renderData,
        isLoading,
        input,
        setInput,
        uppendData,
    }
}

export default useMiunList
